var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "rotate(-180 6 6)",
    fill: "#307CAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 9.62803L7.09058 6.31429C7.09058 6.1046 6.96937 5.99976 6.72695 5.99976L5.2724 5.99976C5.02998 5.99976 4.90877 6.1046 4.90877 6.31429L4.66634 9.62803C4.66634 9.74241 4.70674 9.82819 4.78755 9.88538C4.84816 9.96163 4.92897 9.99976 5.02998 9.99976L6.96937 9.99976C7.07038 9.99976 7.16129 9.96163 7.2421 9.88538C7.3027 9.82819 7.33301 9.74241 7.33301 9.62803Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 4.66626C5.63252 4.66626 5.32335 4.53099 5.07214 4.26046C4.80161 4.00925 4.66634 3.70008 4.66634 3.33293C4.66634 2.96578 4.80161 2.64694 5.07214 2.3764C5.32335 2.1252 5.63253 1.99959 5.99967 1.99959C6.36682 1.99959 6.68566 2.1252 6.9562 2.3764C7.2074 2.64694 7.33301 2.96578 7.33301 3.33293C7.33301 3.70008 7.2074 4.00925 6.9562 4.26046C6.68566 4.53099 6.36682 4.66626 5.99967 4.66626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWarning);
export default __webpack_public_path__ + "static/media/blue-warning.c94a4ee4ffeef70628278bf40feda816.svg";
export { ForwardRef as ReactComponent };